import { authRequest } from '../coopApi';
import { getToken } from '../http';

export const login = (user) => authRequest('login', user);

export const register = (user) => authRequest('register', user);

export const getInfo = () => authRequest('me', { token: getToken() });

export const logout = () => authRequest('logout', { token: getToken() });

// Coop 用户密码保存在 coop-api，改密请求必须走加密认证接口。
export const changePassword = (params) => authRequest('change-password', { token: getToken(), ...params });
